import { Buffer } from "buffer";

export function encodeBase64UUID(objectId) {
    const hex = objectId.toLowerCase();
    const buffer = Buffer.from(hex, 'hex');
  
    return buffer.toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, ''); 
}
  
export function decodeBase64UUID(shortId) {
    const base64 = shortId
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        .padEnd(shortId.length + (4 - shortId.length % 4) % 4, '=');
  
    const buffer = Buffer.from(base64, 'base64');
    return buffer.toString('hex');
}
 